import {
  marketWhereEuropean,
  marketWhereGameList
} from 'utils/constants/sportsbook/favorite-data-fields';

export const getFavoriteSubscribeWhere = (
  gameIDs: number[],
  markets?: 'basic' | 'european'
): Record<string, object> => ({
  game: {
    id: { '@in': gameIDs }
  },
  ...(markets === 'basic'
    ? marketWhereGameList
    : markets === 'european'
    ? marketWhereEuropean
    : {})
});

// in this variable we store ids of mounted useFetchFavoritesData hooks to track and avoid duplicated calls
export const FAVORITE_HOOKS_CACHE: {
  mountedHookIds: Record<'fetchData' | 'fetchIds', string[]>;
  subscribedHookIds: Record<
    'fetchData' | 'fetchIds' | 'fetchMarkets',
    string | null
  >;
  withAdditionalMarkets: boolean;
} = {
  subscribedHookIds: {
    fetchIds: null,
    fetchData: null,
    fetchMarkets: null
  },
  mountedHookIds: {
    fetchIds: [],
    fetchData: []
  },
  withAdditionalMarkets: false
};

export enum EFavoriteActions {
  dataSubscriptionUnmount = 'favorite_dataSubscriptionUnmount'
}
